import { useEffect, useState } from 'react';

export function useKeyPressed(key: string) {
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    window.addEventListener(
      'keydown',
      (event) => {
        if (event.key === key) {
          setIsPressed(true);
        }
      },
      { signal: abortController.signal },
    );
    window.addEventListener(
      'keyup',
      (event) => {
        if (event.key === key) {
          setIsPressed(false);
        }
      },
      { signal: abortController.signal },
    );
    return () => {
      abortController.abort();
    };
  }, []);

  return isPressed;
}
